import { STORE_CHANGE_STORE_STATE } from './action';

import { Map } from 'immutable';

const initialState = Map({
  payload: Map({
    type: '',
    load: false,
  }),
});

function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === STORE_CHANGE_STORE_STATE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  return state;
}

export default reducer;
